import { RenderBrokerList } from './BrokerList';

interface IBrokerListWrapper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[];
  handleRedirect: (
    id: string,
    isCryptoLogin: boolean,
    isForeignPartner: boolean
  ) => void;
  isCryptoLogin?: boolean;
}

export const BrokerListWrapper: React.FC<IBrokerListWrapper> = ({
  data,
  handleRedirect,
  isCryptoLogin = false,
}): JSX.Element => {
  return (
    <>
      {data.map((ele) => {
        const {
          id,
          name,
          type,
          logoUrl,
          isForeignPartner = false,
        } = ele.brokerDetails;
        const brokerName = id || name;
        return (
          <RenderBrokerList
            name={name}
            type={type}
            logoUrl={logoUrl}
            key={brokerName}
            onClickHandler={() =>
              handleRedirect(brokerName, isCryptoLogin, isForeignPartner)
            }
          />
        );
      })}
    </>
  );
};
